import ContentComponent from '../content';

class HtmlComponent extends ContentComponent {
  constructor (component, data, options) {
    super(component, data, options);
  }
}

export default HtmlComponent;
